// Single source of truth for plain-English definitions of internal/technical
// vocabulary shown to learners. Used by <GlossaryTerm> (components/common/GlossaryTerm.jsx)
// so a term is defined once and reused everywhere it appears, instead of each
// page writing its own explanation (or none at all).
//
// Keys are matched case-insensitively by <GlossaryTerm term="...">.

const GLOSSARY = {
  // Git / GitHub
  repo: 'A project folder stored on GitHub.',
  repository: 'A project folder stored on GitHub.',
  commit: 'A saved checkpoint of your work.',
  push: 'Sending saved work from your computer to GitHub.',
  branch: 'A safe copy of the project where you can work without changing the main version.',
  'pull request': 'A request for your work to be reviewed before it is added to the shared project. Often shortened to "PR."',
  pr: 'Short for "pull request" — a request for your work to be reviewed before it is added to the shared project.',
  readme: 'The front page of a repo. It explains what the project is and how to inspect it.',
  pat: 'Short for "Personal Access Token" — a private key that lets Qode Clarity commit to your repo on your behalf.',
  'github pat': 'A Personal Access Token — a private key that lets Qode Clarity commit to your repo on your behalf.',
  collaborator: 'Someone you have given permission to view and edit your GitHub repo.',
  clone: 'Downloading a copy of a GitHub repo onto your own computer so you can edit it locally.',
  merge: 'Combining a branch\'s changes into the main version of the project.',

  // Qode Clarity product features
  'journal coach': 'An AI reviewer that reads your saved lesson notes and suggests stronger, more specific wording for a recruiter or interviewer to read.',
  'evidence intelligence': 'The AI system behind Journal Coach and the portfolio/interview review tools — it reads your saved work and scores how convincing it would look to an employer.',
  journal: 'Your saved notes for a lesson — what you did, what you decided, and what to review later. Also called "journal.md" once pushed to GitHub.',
  'journal.md': 'The file your saved lesson notes get written to once pushed to your GitHub repo.',

  // SOLVE / 5-HOW practice frameworks
  solve: 'A 5-step practice framework — Split, Observe, Look, Verify, Evolve — for breaking down a problem before you code it.',
  '5-how': 'A practice framework for explaining an idea 5 different ways (in code, step-by-step, with a real-life comparison, in a real job, and by showing the result) so it actually sticks.',
  ipops: 'The 5 things to identify when you Split a scenario apart: Input, Problem, Operation, Product, Success.',

  // Cloud / platform engineering acronyms
  rbac: 'Short for "Role-Based Access Control" — a way of granting people only the specific permissions their role needs, not full access to everything.',
  iac: 'Short for "Infrastructure as Code" — describing cloud resources (servers, networks, storage) in a text file instead of clicking through a portal, so the setup can be reviewed and rerun.',
  'ci/cd': 'Short for "Continuous Integration / Continuous Deployment" — automatically testing and publishing code changes instead of doing it by hand.',
  'key vault': 'An Azure service that stores passwords, keys, and other secrets securely instead of leaving them in code.',
  'managed identity': 'An Azure feature that lets one cloud resource securely access another without a password ever being stored in code.',
  dba: 'Short for "Database Administrator" — the person or role responsible for a database\'s performance, backups, and access.',
  lakehouse: 'A data platform that combines a data lake (cheap storage for raw files) with a warehouse (structured, query-ready tables) in one system.',

  // Progress-tracking fields
  'challenge status': "Whether you've started, are working through, or have finished this lesson's practice challenge.",
  confidence: 'A 0-100% self-rating you set yourself on each lesson — how sure you feel you could redo it without notes.',
};

export default GLOSSARY;

export function lookupTerm(term) {
  if (!term) return '';
  return GLOSSARY[String(term).trim().toLowerCase()] || '';
}
